import _ from 'underscore'

const types = []

const filterDefinitions = require.context('./sort/type', false, /\.js$/)

filterDefinitions.keys().forEach((filename) => {

    var definition = filterDefinitions(filename).default

    definition.key = filename.replace('.js', '').replace('./', '')

    types.push(definition)

})

var typesAssoc = {}

_.each(types, function(type) {

    typesAssoc[type.key] = type

})

export default {

    types: types,

    type: typesAssoc

}